import React from 'react'
import { Box, Flex } from 'reflexbox'
import classnames from 'classnames'

import LinkComponent from 'src/components/LinkComponent/LinkComponent'

import * as styles from './ButtonFilled.module.scss'
import { Props } from './types'

const ButtonContent = ({ children }: Props): JSX.Element => (
  <Flex alignItems="center">
    <Box className={styles.text} textAlign="left">
      {children}
    </Box>
  </Flex>
)

const ButtonFilled = ({
  onClick,
  to,
  title,
  children,
  className = '',
  ariaLabel,
}: Props): JSX.Element => {
  const buttonStyles = classnames(styles.button, className)
  return onClick && !to ? (
    <Flex
      aria-label={ariaLabel}
      as="button"
      onClick={onClick}
      className={buttonStyles}
    >
      <ButtonContent>{children}</ButtonContent>
    </Flex>
  ) : to ? (
    <LinkComponent
      to={to}
      onClick={onClick}
      title={title}
      className={buttonStyles}
    >
      <ButtonContent>{children}</ButtonContent>
    </LinkComponent>
  ) : (
    <div />
  )
}

export default ButtonFilled
